.tabs {
  display: flex;
  align-items: center;
  gap: 4px;
  border-bottom: 1px solid var(--vc-border);
  overflow-x: auto;

  .tab {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    font-size: var(--vc-text-md);
    font-weight: var(--vc-weight-medium);
    color: var(--vc-text-muted);
    white-space: nowrap;
    border-bottom: 2px solid transparent;
    margin-bottom: -1px;
    transition: color var(--vc-duration) var(--vc-ease);

    &:hover {
      color: var(--vc-text);
    }

    &.active {
      color: var(--vc-text);
      border-bottom-color: var(--vc-brand);
    }
  }
}

/* Segmented control (pill group) */
.segmented {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  border-radius: var(--vc-radius-md);
  background: var(--vc-gray-soft);

  .segment {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 28px;
    padding: 0 11px;
    border-radius: 8px;
    font-size: var(--vc-text-sm);
    font-weight: var(--vc-weight-medium);
    color: var(--vc-text-muted);
    transition: all var(--vc-duration) var(--vc-ease);
    white-space: nowrap;

    &:hover {
      color: var(--vc-text);
    }

    &.segmentActive {
      background: var(--vc-surface);
      color: var(--vc-text);
      box-shadow: var(--vc-shadow-sm);
    }
  }
}

/* Filter chip */
.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  padding: 0 11px;
  border-radius: var(--vc-radius-pill);
  border: 1px solid var(--vc-border-strong);
  background: var(--vc-surface);
  font-size: var(--vc-text-sm);
  font-weight: var(--vc-weight-medium);
  color: var(--vc-text-secondary);
  transition: all var(--vc-duration) var(--vc-ease);
  white-space: nowrap;

  // Declared before `&:hover` so the hover colours keep winning (same specificity now).
  &.chipActive {
    background: var(--vc-brand-soft);
    border-color: var(--vc-brand-soft-border);
    color: var(--vc-brand);
  }

  &:hover {
    border-color: var(--vc-text-faint);
    color: var(--vc-text);
  }

  svg {
    width: 14px;
    height: 14px;
  }
}
